import React, { Component } from 'react';
import {
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBBtn,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBCardHeader
} from 'mdbreact';
import Select from 'react-select';
import QRCode from 'qrcode';
import axios from '../../axios';
import _ from 'lodash';
class GenerateVenueWifiHandout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            venues: [],
            selectedVenue: null,
            selectedUnit: null,
            loadingVenues: true,
            generatingHandout: false,
            includeQRCodes: true,
            handoutType: 'individual', // 'individual' or 'venue'
            unitsList: [],
            keyPoolList: [],
            loadingUnits: false
        };
    }
    componentDidMount() {
        this.fetchVenues();
    }
    // Fetch available venues
    fetchVenues = async () => {
        try {
            const body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                UserTimeZone: new Date().getTimezoneOffset()
            };
            const response = await axios.post("/networkoperatorconsole/venues/listVenues", body);
            console.log(Object.keys(response.data.VenueList))
            const venueOptions = Object.keys(response.data.VenueList).map(VenueId => ({
                value: VenueId,
                label: response.data.VenueList[VenueId].VenueName,
                data: response.data.VenueList[VenueId]
            }));
            console.log(venueOptions)
            this.setState({ 
                venues: venueOptions,
                loadingVenues: false 
            });
        } catch (error) {
            console.error('Error fetching venues:', error);
            this.setState({ loadingVenues: false });
        }
    };
    // Fetch venue details including units and key pools
    fetchVenueDetails = async (venueId) => {
        this.setState({ loadingUnits: true });
        try {
            const body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                VenueID: venueId,
                UserTimeZone: new Date().getTimezoneOffset()
            };
            const response = await axios.post("/networkoperatorconsole/venues/listVenueDetails", body);
            const venueData = response.data[venueId];
            const subscriptionsObj = venueData["Subscriptions"] || {};
            this.getKeypools(venueId);
            // const keyPoolList = venueData["Keypools"] || {};
            // var sortedKeys = _(keyPoolList)
            //                     .map(function (v, k) {
            //                         // insert the key into the object
            //                         return _.merge({}, v, { key: k });
            //                     })
            //                     .sortBy("DisplayOrder") // sort by name
            //                     .value();
            // Convert units object to array
            const unitsList = Object.keys(subscriptionsObj).map(unitKey => ({
                unitKey: unitKey,
                ...subscriptionsObj[unitKey]
            }));
            this.setState({
                unitsList,
                // keyPoolList,
                // sortedKeys,
                loadingUnits: false
            });
        } catch (error) {
            console.error('Error fetching venue details:', error);
            this.setState({ loadingUnits: false });
        }
    };
    getKeypools = async (venueId) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: venueId,
        };
        await axios
            .post("/networkoperatorconsole/keypools/listKeypools", body, {
                headers: {},
            })
            .then((response) => {
                var sortedKeys = _(response.data["myKeyPoolList"])
                    .map(function (v, k) {
                        // insert the key into the object
                        return _.merge({}, v, { key: k });
                    })
                    .sortBy("DisplayOrder") // sort by name
                    .value();
                this.setState({ 
                    keyPoolList: sortedKeys,
                    sortedKeys: sortedKeys
                });
            })
            .catch((error) => {});
    }
    // Handle venue selection
    handleVenueSelect = (selectedOption) => {
        this.setState({ selectedVenue: selectedOption, selectedUnit: null }); // Reset unit selection
        if (selectedOption) {
            this.fetchVenueDetails(selectedOption.value);
        }
    };
    // Handle unit selection
    handleUnitSelect = (selectedOption) => {
        this.setState({ selectedUnit: selectedOption });
    };
    // Build unit options for dropdown
    getUnitOptions = () => {
        console.log(this.state.unitsList)
        const unitOptions = Array.isArray(this.state.unitsList) 
            ? this.state.unitsList
                .filter(unit => {
                    console.log('Unit:', unit)
                    return unit && unit.UnitID;
                })
                .map(unit => ({
                    value: unit.unitKey,
                    label: `Unit: ${unit.UnitID} - Building: ${unit.UnitBuilding} - Floor: ${unit.UnitFloor}`,
                    data: unit
                })) 
            : [];
        console.log(unitOptions)
        return unitOptions;
        // const options = [];
        // console.log(unitsList)
        // Object.keys(unitsList).forEach(buildingKey => {
        //     const building = unitsList[buildingKey];
        //     Object.keys(building).forEach(floorKey => {
        //         const floor = building[floorKey];
        //         Object.keys(floor).forEach(unitKey => {
        //             const unit = floor[unitKey];
        //             console.log(unit)
        //             if (unit && unit.UnitNumber) {
        //                 options.push({
        //                     value: unit.UnitID_internal,
        //                     label: `${unit.UnitNumber} (Building: ${buildingKey}, Floor: ${floorKey})`,
        //                     data: unit,
        //                     buildingKey,
        //                     floorKey,
        //                     unitKey
        //                 });
        //             }
        //         });
        //     });
        // });
        // return options.sort((a, b) => a.label.localeCompare(b.label));
    };
    // Generate WiFi QR Code
    generateWiFiQR = async (ssid, password, security = 'WPA') => {
        const wifiString = `WIFI:T:${security};S:${ssid};P:${password};;`;
        try {
            return await QRCode.toDataURL(wifiString, {
                width: 120,
                margin: 1,
                color: {
                    dark: '#2c3e50',
                    light: '#ffffff'
                }
            });
        } catch (err) {
            console.error('QR Code generation failed:', err);
            return null;
        }
    };
    // WiFi icon SVG
    wifiIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 410 410" xml:space="preserve">
<g>
	<g>
		<g>
			<circle cx="205" cy="304.873" r="47.05"/>
			<path d="M205,153.887c-57.634,0-109.614,34.209-132.423,87.155c-5.607,13.018,0.399,28.114,13.415,33.722     c13.018,5.608,28.115-0.396,33.722-13.414c14.692-34.1,48.169-56.136,85.286-56.136s70.594,22.036,85.286,56.136     c4.182,9.707,13.641,15.517,23.581,15.517c3.389,0,6.834-0.674,10.142-2.103c13.019-5.606,19.022-20.704,13.416-33.722     C314.614,188.096,262.634,153.887,205,153.887z"/>
			<path d="M405.797,166.646C361.235,98.664,286.17,58.078,205,58.078S48.765,98.664,4.203,166.646     c-7.771,11.854-4.459,27.761,7.394,35.532c4.338,2.844,9.219,4.203,14.045,4.203c8.362,0,16.561-4.081,21.487-11.598     c35.044-53.461,94.06-85.38,157.871-85.38c63.811,0,122.827,31.918,157.871,85.379c7.77,11.853,23.678,15.166,35.533,7.395     C410.256,194.407,413.567,178.5,405.797,166.646z"/>
		</g>
	</g>
</g>
</svg>`;
    // Fetch WiFi credentials from venue data
    fetchWiFiCredentials = async () => {
        try {
            if (!this.state.selectedVenue || !Array.isArray(this.state.unitsList) || !this.state.keyPoolList) {
                return { units: [], venueName: '' };
            }
            const units = [];
            const unitsList = this.state.unitsList;
            console.log(unitsList)
            const keyPoolList = this.state.sortedKeys;
            // Get the first available keypool (SSID/password)
            const firstKeyPool = Object.values(keyPoolList)[0];
            if (!firstKeyPool || !firstKeyPool.ssid) {
                return { units: [], venueName: this.state.selectedVenue.label };
            }
            const ssid = firstKeyPool.ssid;
            const password = firstKeyPool.psk || 'password'; // fallback if no psk
            // If specific units are selected, only return those units
            if (this.state.selectedUnit && Array.isArray(this.state.selectedUnit) && this.state.selectedUnit.length > 0) {
                console.log("Selected Units: ", this.state.selectedUnit);
                this.state.selectedUnit.forEach(selectedOption => {
                    const selectedUnitData = unitsList.find(unit => unit.unitKey === selectedOption.value);
                    console.log("Selected Unit Data: ", selectedUnitData);
                    if (selectedUnitData) {
                        units.push({
                            unitID: selectedUnitData.UnitID,
                            building: selectedUnitData.UnitBuilding || 'Main',
                            floor: selectedUnitData.UnitFloor || 'Ground',
                            ssid: ssid,
                            psk: selectedUnitData.psk,
                            security: 'WPA2',
                            unitData: selectedUnitData
                        });
                    }
                });
            } else {
                // Process all units
                unitsList.forEach(unitData => {
                    console.log("unitData Unit Data: ", unitData);  
                    if (unitData && unitData.UnitID) {
                        units.push({
                            unitID: unitData.UnitID,
                            building: unitData.UnitBuilding || 'Main',
                            floor: unitData.UnitFloor || 'Ground',
                            ssid: ssid,
                            psk: unitData.psk || password, // Use unit's PSK if available, otherwise use keypool password
                            security: 'WPA2',
                            unitData: unitData
                        });
                    }
                });
            }
            console.log("Units Returned: ", units);
            return {
                units: units,
                venueName: this.state.selectedVenue.label
            };
        } catch (error) {
            console.error("Error fetching WiFi credentials:", error);
            return { units: [], venueName: this.state.selectedVenue?.label || '' };
        }
    };
    // Generate individual handouts
    generateIndividualHandouts = async () => {
        this.setState({ generatingHandout: true });
        const wifiData = await this.fetchWiFiCredentials();
        console.log(wifiData)
        if (wifiData.units.length === 0) {
            alert('No units found for this venue');
            this.setState({ generatingHandout: false });
            return;
        }
        const printWindow = window.open('', '_blank');
        let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Wi-Fi Access Cards</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    * {
                        box-sizing: border-box;
                    }
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif; 
                        margin: 0; 
                        padding: 20px;
                        background: #f8f9fa;
                        line-height: 1.5;
                        color: #2c3e50;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                    }
                    .wifi-card { 
                        width: 380px;
                        height: 580px;
                        background: white;
                        margin: 20px auto;
                        padding: 30px;
                        border-radius: 16px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                        page-break-after: always;
                        page-break-inside: avoid;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        border: 1px solid #e3e8ee;
                    }
                    .wifi-card:last-child { 
                        page-break-after: avoid; 
                    }
                    .wifi-icon {
                        text-align: center;
                        margin-bottom: 16px;
                    }
                    .wifi-icon svg {
                        width: 48px;
                        height: 36px;
                        color: #3498db;
                    }
                    .header-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 32px;
                        letter-spacing: 0.5px;
                    }
                    .main-content {
                        display: flex;
                        gap: 24px;
                        flex-grow: 1;
                        min-height: 150px;
                    }
                    .connection-section {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .qr-section {
                        width: 140px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                    }
                    .network-info, .password-info {
                        margin-bottom: 0;
                        text-align: center;
                    }
                    .network-label, .password-label {
                        font-size: 14px;
                        font-weight: 600;
                        color: #7f8c8d;
                        margin-bottom: 6px;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .network-name {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        margin-bottom: 0;
                        border: none;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .password-value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        letter-spacing: 0;
                        margin-bottom: 0;
                        border: none;
                        font-family: 'Inter', sans-serif;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .qr-label {
                        font-size: 11px;
                        color: #95a5a6;
                        margin-bottom: 8px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        line-height: 1.3;
                    }
                    .qr-code {
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #ecf0f1;
                        display: block;
                    }
                    .footer-section {
                        margin-top: auto;
                        padding-top: 24px;
                        border-top: 1px solid #ecf0f1;
                    }
                    .terms-text {
                        font-size: 9px;
                        color: #95a5a6;
                        text-align: center;
                        line-height: 1.4;
                        margin-bottom: 12px;
                    }
                    .unit-info {
                        font-size: 10px;
                        color: #7f8c8d;
                        text-align: center;
                        margin-bottom: 16px;
                        font-weight: 500;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .brand-section {
                        text-align: center;
                    }
                    .brand-logo {
                        font-size: 14px;
                        font-weight: 700;
                        color: #3498db;
                        margin-bottom: 2px;
                        text-transform: none;
                        letter-spacing: 0.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .brand-subtitle {
                        font-size: 10px;
                        font-weight: 400;
                        color: #3498db;
                        margin-bottom: 8px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .copyright {
                        font-size: 8px;
                        color: #bdc3c7;
                        text-align: center;
                    }
                    @media print {
                        body { 
                            background: white !important; 
                            padding: 0 !important; 
                        }
                        .wifi-card { 
                            box-shadow: none !important; 
                            margin: 0 auto !important;
                            page-break-inside: avoid !important;
                            border: 1px solid #e3e8ee !important;
                        }
                        @page {
                            margin: 0.5in;
                            size: auto;
                        }
                    }
                    @media screen and (max-width: 480px) {
                        .wifi-card {
                            width: 90%;
                            margin: 10px auto;
                            padding: 20px;
                        }
                        .main-content {
                            flex-direction: column;
                            gap: 16px;
                        }
                        .qr-section {
                            width: 100%;
                        }
                        .header-title {
                            font-size: 16px;
                        }
                    }
                </style>
            </head>
            <body>
        `;
        // Generate QR codes for units if needed
        const unitsWithQR = await Promise.all(
            wifiData.units.map(async (unit) => {
                if (this.state.includeQRCodes) {
                    const qrDataURL = await this.generateWiFiQR(unit.ssid, unit.psk, unit.security);
                    return { ...unit, qrCode: qrDataURL };
                }
                return unit;
            })
        );
        unitsWithQR.forEach((unit, index) => {
            htmlContent += `
                <div class="wifi-card">
                    <div class="wifi-icon">${this.wifiIconSVG}</div>
                    <div class="header-title">CONNECT TO WI-FI</div>
                    <div class="main-content">
                        <div class="connection-section">
                            <div class="network-info">
                                <div class="network-label">Network</div>
                                <div class="network-name">${unit.ssid}</div>
                            </div>
                            <div class="password-info">
                                <div class="password-label">Password</div>
                                <div class="password-value">${unit.psk}</div>
                            </div>
                        </div>
                        ${this.state.includeQRCodes && unit.qrCode ? `
                            <div class="qr-section">
                                <div class="qr-label">or scan here to connect</div>
                                <img src="${unit.qrCode}" alt="WiFi QR Code" class="qr-code" />
                            </div>
                        ` : ''}
                    </div>
                    <div class="footer-section">
                        <div class="terms-text">
                            By connecting you agree to the Wi-Fi Terms of Service found on<br>
                            ${sessionStorage.getItem("PrivacyPolicyURL") || "your property management website"}<br>
                            For questions or to request a printout of terms, please contact your<br>
                            property management
                        </div>
                        <div class="unit-info">
                            Building ${unit.building} Floor ${unit.floor} Unit ${unit.unitID}
                        </div>
                        <div class="brand-section">
                            <div class="brand-logo">
                                <img src="${sessionStorage.getItem("logoURL") || sessionStorage.getItem("logo") || "logo.png"}" alt="Logo" style="height: 20px; margin-right: 6px;" />
                                ${sessionStorage.getItem("clientName") || "GROOVE"}
                            </div>
                        </div>
                        <div class="copyright">©2025 ${sessionStorage.getItem("clientName") || "GROOVE"} Technology Solutions. All rights reserved.</div>
                    </div>
                </div>
            `;
        });
        htmlContent += `</body></html>`;
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        // Auto-print after content loads
        setTimeout(() => {
            printWindow.print();
        }, 1000);
        this.setState({ generatingHandout: false });
    };
    // Generate venue summary handout
    generateVenueHandout = async () => {
        this.setState({ generatingHandout: true });
        const wifiData = await this.fetchWiFiCredentials();
        if (wifiData.units.length === 0) {
            alert('No units found for this venue');
            this.setState({ generatingHandout: false });
            return;
        }
        const printWindow = window.open('', '_blank');
        let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Wi-Fi Access Cards - ${wifiData.venueName}</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    * {
                        box-sizing: border-box;
                    }
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif; 
                        margin: 0; 
                        padding: 20px;
                        background: #f8f9fa;
                        line-height: 1.5;
                        color: #2c3e50;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                    }
                    .wifi-card { 
                        width: 380px;
                        height: 580px;
                        background: white;
                        margin: 20px auto;
                        padding: 30px;
                        border-radius: 16px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                        page-break-after: always;
                        page-break-inside: avoid;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        border: 1px solid #e3e8ee;
                    }
                    .wifi-card:last-child { 
                        page-break-after: avoid; 
                    }
                    .wifi-icon {
                        text-align: center;
                        margin-bottom: 16px;
                    }
                    .wifi-icon svg {
                        width: 48px;
                        height: 36px;
                        color: #3498db;
                    }
                    .header-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 32px;
                        letter-spacing: 0.5px;
                    }
                    .main-content {
                        display: flex;
                        gap: 24px;
                        flex-grow: 1;
                        min-height: 150px;
                    }
                    .connection-section {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .qr-section {
                        width: 140px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                    }
                    .network-info, .password-info {
                        margin-bottom: 0;
                        text-align: center;
                    }
                    .network-label, .password-label {
                        font-size: 14px;
                        font-weight: 600;
                        color: #7f8c8d;
                        margin-bottom: 6px;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .network-name {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        margin-bottom: 0;
                        border: none;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .password-value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        letter-spacing: 0;
                        margin-bottom: 0;
                        border: none;
                        font-family: 'Inter', sans-serif;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .qr-label {
                        font-size: 11px;
                        color: #95a5a6;
                        margin-bottom: 8px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        line-height: 1.3;
                    }
                    .qr-code {
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #ecf0f1;
                        display: block;
                    }
                    .footer-section {
                        margin-top: auto;
                        padding-top: 24px;
                        border-top: 1px solid #ecf0f1;
                    }
                    .terms-text {
                        font-size: 9px;
                        color: #95a5a6;
                        text-align: center;
                        line-height: 1.4;
                        margin-bottom: 12px;
                    }
                    .unit-info {
                        font-size: 10px;
                        color: #7f8c8d;
                        text-align: center;
                        margin-bottom: 16px;
                        font-weight: 500;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .brand-section {
                        text-align: center;
                    }
                    .brand-logo {
                        font-size: 14px;
                        font-weight: 700;
                        color: #3498db;
                        margin-bottom: 2px;
                        text-transform: none;
                        letter-spacing: 0.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .brand-subtitle {
                        font-size: 10px;
                        font-weight: 400;
                        color: #3498db;
                        margin-bottom: 8px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .copyright {
                        font-size: 8px;
                        color: #bdc3c7;
                        text-align: center;
                    }
                    @media print {
                        body { 
                            background: white !important; 
                            padding: 0 !important; 
                        }
                        .wifi-card { 
                            box-shadow: none !important; 
                            margin: 0 auto !important;
                            page-break-inside: avoid !important;
                            border: 1px solid #e3e8ee !important;
                        }
                        @page {
                            margin: 0.5in;
                            size: auto;
                        }
                    }
                    @media screen and (max-width: 480px) {
                        .wifi-card {
                            width: 90%;
                            margin: 10px auto;
                            padding: 20px;
                        }
                        .main-content {
                            flex-direction: column;
                            gap: 16px;
                        }
                        .qr-section {
                            width: 100%;
                        }
                        .header-title {
                            font-size: 16px;
                        }
                    }
                </style>
            </head>
            <body>
        `;
        // Generate QR codes for all units if needed
        const unitsWithQR = await Promise.all(
            wifiData.units?.map(async (unit) => {
                if (this.state.includeQRCodes) {
                    const qrDataURL = await this.generateWiFiQR(unit.ssid, unit.psk, unit.security);
                    return { ...unit, qrCode: qrDataURL };
                }
                return unit;
            }) || []
        );
        unitsWithQR.forEach((unit, index) => {
            htmlContent += `
                <div class="wifi-card">
                    <div class="wifi-icon">
                        ${this.wifiIconSVG}
                    </div>
                    <div class="header-title">CONNECT TO WI-FI</div>
                    <div class="main-content">
                        <div class="connection-section">
                            <div class="network-info">
                                <div class="network-label">Network</div>
                                <div class="network-name">${unit.ssid}</div>
                            </div>
                            <div class="password-info">
                                <div class="password-label">Password</div>
                                <div class="password-value">${unit.psk}</div>
                            </div>
                        </div>
                        ${this.state.includeQRCodes && unit.qrCode ? `
                            <div class="qr-section">
                                <div class="qr-label">or scan here to connect</div>
                                <img src="${unit.qrCode}" alt="WiFi QR Code" class="qr-code" />
                            </div>
                        ` : ''}
                    </div>
                    <div class="footer-section">
                        <div class="terms-text">
                            By connecting you agree to the Wi-Fi Terms of Service found on<br>
                            ${sessionStorage.getItem("PrivacyPolicyURL") || "your property management website"}<br>
                            For questions or to request a printout of terms, please contact your<br>
                            property management
                        </div>
                        <div class="unit-info">
                            Building ${unit.building} Floor ${unit.floor} Unit ${unit.unitID}
                        </div>
                        <div class="brand-section">
                            <div class="brand-logo">
                                <img src="${sessionStorage.getItem("logoURL") || sessionStorage.getItem("logo") || "logo.png"}" alt="Logo" style="height: 20px; margin-right: 6px;" />
                                ${sessionStorage.getItem("clientName") || "GROOVE"}
                            </div>
                        </div>
                        <div class="copyright">©2025 ${sessionStorage.getItem("clientName") || "GROOVE"} Technology Solutions. All rights reserved.</div>
                    </div>
                </div>
            `;
        });
        htmlContent += `
            </body>
            </html>
        `;
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 1000);
        this.setState({ generatingHandout: false });
    };
    render() {
        const { isOpen, toggle } = this.props;
        const { venues, selectedVenue, selectedUnit, loadingVenues, generatingHandout, includeQRCodes, handoutType, loadingUnits } = this.state;
        const customSelectStyles = {
            control: (provided) => ({
                ...provided,
                minHeight: '42px',
                borderColor: '#ced4da',
                borderRadius: '6px',
                '&:hover': {
                    borderColor: '#80bdff'
                }
            }),
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
                color: state.isSelected ? 'white' : '#2c3e50'
            })
        };
        return (
         <>
                <MDBModalHeader toggle={toggle}>
                    <h4>Generate Venue Wi-Fi Handouts</h4>
                    <p>Create printable Wi-Fi password handouts for units or entire venue</p>
                </MDBModalHeader>
                <MDBModalBody>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>
                                                Select Venue
                                            </label>
                                            <Select
                                                value={selectedVenue}
                                                onChange={this.handleVenueSelect}
                                                options={venues}
                                                isLoading={loadingVenues}
                                                placeholder={loadingVenues ? "Loading venues..." : "Choose a venue..."}
                                                styles={customSelectStyles}
                                                isSearchable
                                                isClearable
                                            />
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                {selectedVenue && (
                                    <>
                                        <MDBRow>
                                            <MDBCol md="12">
                                                <div style={{ marginBottom: '20px' }}>
                                                    <h5>Handout Type</h5>
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <label style={{ 
                                                            display: 'block', 
                                                            marginBottom: '10px', 
                                                            padding: '12px 16px',
                                                            border: handoutType === 'individual' ? '2px solid #007bff' : '2px solid #e9ecef',
                                                            borderRadius: '8px',
                                                            backgroundColor: handoutType === 'individual' ? '#f8f9ff' : '#ffffff',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s ease-in-out',
                                                            boxShadow: handoutType === 'individual' ? '0 2px 8px rgba(0, 123, 255, 0.15)' : 'none'
                                                        }}>
                                                            <input
                                                                type="radio"
                                                                name="handoutType"
                                                                value="individual"
                                                                checked={handoutType === 'individual'}
                                                                onChange={(e) => this.setState({ handoutType: e.target.value })}
                                                                style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                                                            />
                                                            <strong style={{ color: handoutType === 'individual' ? '#007bff' : '#495057' }}>
                                                                Individual Unit Cards
                                                            </strong>
                                                            <div style={{ 
                                                                fontSize: '14px', 
                                                                color: handoutType === 'individual' ? '#6c757d' : '#6c757d',
                                                                marginTop: '4px',
                                                            }}>
                                                                Generate handout cards for selected units only
                                                            </div>
                                                        </label>
                                                        <label style={{ 
                                                            display: 'block',
                                                            padding: '12px 16px',
                                                            border: handoutType === 'venue' ? '2px solid #007bff' : '2px solid #e9ecef',
                                                            borderRadius: '8px',
                                                            backgroundColor: handoutType === 'venue' ? '#f8f9ff' : '#ffffff',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s ease-in-out',
                                                            boxShadow: handoutType === 'venue' ? '0 2px 8px rgba(0, 123, 255, 0.15)' : 'none'
                                                        }}>
                                                            <input
                                                                type="radio"
                                                                name="handoutType"
                                                                value="venue"
                                                                checked={handoutType === 'venue'}
                                                                onChange={(e) => this.setState({ handoutType: e.target.value })}
                                                                style={{ marginRight: '12px', transform: 'scale(1.2)' }}
                                                            />
                                                            <strong style={{ color: handoutType === 'venue' ? '#007bff' : '#495057' }}>
                                                                All Units
                                                            </strong>
                                                            <div style={{ 
                                                                fontSize: '14px', 
                                                                color: handoutType === 'venue' ? '#6c757d' : '#6c757d',
                                                                marginTop: '4px',
                                                            }}>
                                                                Generate handout cards for every unit in the venue
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        {/* <MDBRow>
                                            <MDBCol md="6">
                                                <div style={{ marginBottom: '20px' }}>
                                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: '600' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={includeQRCodes}
                                                            onChange={(e) => this.setState({ includeQRCodes: e.target.checked })}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        Include QR Codes
                                                    </label>
                                                    <small style={{ color: '#6c757d', marginTop: '4px', display: 'block' }}>
                                                        Add QR codes for easy device connection
                                                    </small>
                                                </div>
                                            </MDBCol>
                                        </MDBRow> */}
                                        {handoutType === 'individual' && (
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <h5>Select Units</h5>
                                                        <Select
                                                            value={this.state.selectedUnit}
                                                            onChange={this.handleUnitSelect}
                                                            options={this.getUnitOptions()}
                                                            isLoading={loadingUnits}
                                                            placeholder={loadingUnits ? "Loading units..." : "Choose units for individual handout cards..."}
                                                            styles={{
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    minHeight: '42px',
                                                                    borderColor: '#ced4da',
                                                                    borderRadius: '6px',
                                                                    '&:hover': {
                                                                        borderColor: '#80bdff'
                                                                    }
                                                                }),
                                                                option: (provided, state) => ({
                                                                    ...provided,
                                                                    backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
                                                                    color: state.isSelected ? 'white' : '#2c3e50'
                                                                }),
                                                                multiValue: (provided) => ({
                                                                    ...provided,
                                                                    backgroundColor: '#007bff',
                                                                    color: 'white'
                                                                }),
                                                                multiValueLabel: (provided) => ({
                                                                    ...provided,
                                                                    color: 'white'
                                                                }),
                                                                multiValueRemove: (provided) => ({
                                                                    ...provided,
                                                                    color: 'white',
                                                                    ':hover': {
                                                                        backgroundColor: '#0056b3',
                                                                        color: 'white'
                                                                    }
                                                                })
                                                            }}
                                                            isSearchable
                                                            isClearable
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            isDisabled={loadingUnits || this.getUnitOptions().length === 0}
                                                        />
                                                        <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <small style={{ color: '#666' }}>
                                                                Select multiple units. Use the search box to filter options.
                                                            </small>
                                                            <div>
                                                                {this.getUnitOptions().length > 0 && (!this.state.selectedUnit || this.state.selectedUnit.length < this.getUnitOptions().length) && (
                                                                    <MDBBtn 
                                                                        size="sm" 
                                                                        color="primary" 
                                                                        onClick={() => this.setState({ selectedUnit: this.getUnitOptions() })}
                                                                        style={{ padding: '4px 8px', fontSize: '12px', marginRight: '8px' }}
                                                                    >
                                                                        Select All
                                                                    </MDBBtn>
                                                                )}
                                                                {this.state.selectedUnit && this.state.selectedUnit.length > 0 && (
                                                                    <MDBBtn 
                                                                        size="sm" 
                                                                        color="secondary" 
                                                                        onClick={() => this.setState({ selectedUnit: null })}
                                                                        style={{ padding: '4px 8px', fontSize: '12px' }}
                                                                    >
                                                                        Clear All ({this.state.selectedUnit.length})
                                                                    </MDBBtn>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {!loadingUnits && this.getUnitOptions().length === 0 && (
                                                            <small style={{ color: '#dc3545', marginTop: '4px', display: 'block' }}>
                                                                No units found for this venue
                                                            </small>
                                                        )}
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        )}
                                        {loadingUnits && (
                                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading units...</span>
                                                </div>
                                                <p style={{ marginTop: '10px' }}>Loading venue details...</p>
                                            </div>
                                        )}
                                        {/* {!loadingUnits && Array.isArray(this.state.unitsList) && this.state.unitsList.length > 0 && (
                                            <div style={{ backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}>
                                                <h6 style={{ marginBottom: '8px' }}>Venue Details:</h6>
                                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                                    <strong>Units found:</strong> {this.state.unitsList.length}
                                                </p>
                                                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                                                    <strong>Networks available:</strong> {Object.keys(this.state.keyPoolList).length}
                                                </p>
                                            </div>
                                        )} */}
                                    </>
                                )}
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBBtn color="primary" onClick={toggle}>
                        Cancel
                    </MDBBtn>
                    <MDBBtn 
                        color="primary" 
                        onClick={handoutType === 'individual' ? this.generateIndividualHandouts : this.generateVenueHandout}
                        disabled={!selectedVenue || generatingHandout || loadingUnits || (handoutType === 'individual' && (!selectedUnit || !Array.isArray(selectedUnit) || selectedUnit.length === 0))}
                    >
                        {generatingHandout ? (
                            <>
                                <div className="spinner-border spinner-border-sm mr-2" role="status">
                                    <span className="sr-only">Generating...</span>
                                </div>
                                Generating...
                            </>
                        ) : (
                            `Generate ${handoutType === 'individual' ? 'Individual Cards' : 'Handouts'}`
                        )}
                    </MDBBtn>
                </MDBModalFooter>
                </>
        );
    }
}
export default GenerateVenueWifiHandout;
